<!-- Global incoming-call popup. Mounted once in the main layout so it rings on
     ANY page. Shows while meeting.state.room.status === 'ringing'; the service
     dismisses it by itself when the caller gives up or the invite times out. -->
<template>
  <transition name="incoming-fade">
    <div v-if="ringing" class="incoming-overlay">
      <div class="incoming-card">
        <div class="incoming-pulse">
          <vs-avatar :src="inviter.avatar" :text="inviter.name" size="90px" />
        </div>
        <h3 class="mt-4 mb-1">{{ inviter.name }}</h3>
        <p class="text-grey mb-6">Incoming video call…</p>

        <div class="incoming-actions">
          <div class="incoming-action">
            <vs-button radius color="danger" size="large" icon-pack="feather" icon="icon-phone-off" @click="reject" />
            <span>Decline</span>
          </div>
          <div class="incoming-action">
            <vs-button radius color="success" size="large" icon-pack="feather" icon="icon-video" @click="accept" />
            <span>Accept</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import meeting from '@/services/meeting.js'
import { startRingtone, stopRingtone } from '@/services/ringtone.js'

export default {
  computed: {
    inviter () { return meeting.state.room.inviter || { name: '', avatar: null } },
    ringing () { return meeting.state.room.status === 'ringing' }
  },
  watch: {
    ringing (val) {
      if (val) startRingtone()
      else stopRingtone()
    }
  },
  methods: {
    accept () {
      stopRingtone()
      meeting.acceptIncoming()
      // The call surface is a global floating window (CallOverlay) — no navigation needed.
    },
    reject () {
      stopRingtone()
      meeting.rejectIncoming()
    }
  },
  beforeDestroy () { stopRingtone() }
}
</script>

<style scoped>
.incoming-overlay {
  position: fixed; inset: 0; z-index: 99999;
  display: flex; align-items: center; justify-content: center;
  background: rgba(0,0,0,.55);
}
.incoming-card {
  background: #fff; border-radius: 16px; padding: 32px 40px;
  text-align: center; box-shadow: 0 20px 60px rgba(0,0,0,.4);
  min-width: 320px;
}
.incoming-actions { display: flex; gap: 48px; justify-content: center; }
.incoming-action { display: flex; flex-direction: column; align-items: center; gap: 8px; font-size: 13px; }
.incoming-pulse { display: inline-block; border-radius: 50%; animation: incoming-pulse 1.4s infinite; }
@keyframes incoming-pulse {
  0%   { box-shadow: 0 0 0 0 rgba(40,199,111,.5); }
  70%  { box-shadow: 0 0 0 18px rgba(40,199,111,0); }
  100% { box-shadow: 0 0 0 0 rgba(40,199,111,0); }
}
.incoming-fade-enter-active, .incoming-fade-leave-active { transition: opacity .2s; }
.incoming-fade-enter, .incoming-fade-leave-to { opacity: 0; }
</style>
